import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CaseTextState {
  caseText: string
  setCaseText: (text: string) => void
  clearCaseText: () => void
  getAndClearCaseText: () => string
}

export const useCaseTextStore = create<CaseTextState>()(
  persist(
    (set, get) => ({
      caseText: '',
      setCaseText: (text: string) => set({ caseText: text }),
      clearCaseText: () => set({ caseText: '' }),
      getAndClearCaseText: () => {
        const text = get().caseText
        set({ caseText: '' })
        return text
      }
    }),
    {
      name: 'case-text-storage',
    }
  )
)